export default {
    createCompanyHoliday: 'Create Company Holiday',
    updateCompanyHoliday: 'Edit Company Holiday',
    name: 'Name',
    date: 'Date',
    description: 'Description',
    thisFieldIsRequired: 'This field is required',
    thisFieldIsExceededCharacters: 'This field is exceeded 255 characters',
    save: 'Save',
    congratulation: 'Congratulation',
    companyHolidayIsUpdated: 'Company Holiday is updated',
    companyHolidayIsCreated: 'Company Holiday is created'
}
